import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { ACCOUNT_TYPE } from "../../../utils/constants";
import { useMemo } from "react";

const OpenRoute = ({ children }) => {
  const { token, loading: authLoading } = useSelector((state) => state.auth);
  const { user, loading: profileLoading } = useSelector((state) => state.profile);
  const location = useLocation();

  const isLoading = useMemo(
    () => authLoading || profileLoading,
    [authLoading, profileLoading]
  );

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-black">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue-500 border-t-transparent"></div>
        <span className="ml-4 text-xl">Loading...</span>
      </div>
    );
  }

  // ✅ Only redirect if token + user exist AND you're on a public route
  if (token && user) {
    if (location.pathname === "/login" || location.pathname === "/signup") {
      switch (user.accountType) {
        case ACCOUNT_TYPE.SUPERADMIN:
          return <Navigate to="/dashboard/superadmin" replace />;
        case ACCOUNT_TYPE.ADMIN:
          return <Navigate to="/dashboard/admin" replace />;
        case ACCOUNT_TYPE.EMPLOYEE:
          return <Navigate to="/dashboard/employee" replace />;
        default:
          return <Navigate to="/features" replace />;
      }
    }
  }

  return children;
};

export default OpenRoute;
